/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbMetierAgrementGridDto } from './FcbMetierAgrementGridDto';
import {
    FcbMetierAgrementGridDtoFromJSON,
    FcbMetierAgrementGridDtoFromJSONTyped,
    FcbMetierAgrementGridDtoToJSON,
} from './FcbMetierAgrementGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbMetierAgrementGridDtoPaginatedResults
 */
export interface FcbMetierAgrementGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbMetierAgrementGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbMetierAgrementGridDto>}
     * @memberof FcbMetierAgrementGridDtoPaginatedResults
     */
    results?: Array<FcbMetierAgrementGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbMetierAgrementGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbMetierAgrementGridDtoPaginatedResults interface.
 */
export function instanceOfFcbMetierAgrementGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbMetierAgrementGridDtoPaginatedResultsFromJSON(json: any): FcbMetierAgrementGridDtoPaginatedResults {
    return FcbMetierAgrementGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbMetierAgrementGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbMetierAgrementGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbMetierAgrementGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbMetierAgrementGridDtoPaginatedResultsToJSON(value?: FcbMetierAgrementGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbMetierAgrementGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

